import { useTranslation } from "react-i18next"

import avatar from "/assets/images/avatar.png"

import style from "./TicketsStyle.module.css"

// TODO: check this
export default function TicketMessage({
  user,
  ele,
}: {
  user: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ele: any
}) {
  const { t } = useTranslation()

  return (
    <>
      <div className="d-flex gap-3">
        {user === "user" && (
          <div className={style["img_con"]}>
            <img src={avatar} alt="Agent Avatar" />
          </div>
        )}
        <div
          className={`${style["message"]} ${
            user === "agent" ? style["user"] : style["agent"]
          }`}
        >
          {ele?.type == "1" ? (
            <div className="d-flex flex-column align-items-center gap-3">
              <audio className="w-auto" controls>
                <source src={ele.content} type="audio/mpeg" />
                {t("audioRecorder.noSupport")}
              </audio>
            </div>
          ) : ele?.type == "2" ? (
            <div className="d-flex flex-column justify-content-center gap-3">
              <img
                src={
                  typeof ele.content === "string"
                    ? ele.content
                    : URL.createObjectURL(ele.content)
                }
                alt="Uploaded Image"
                style={{
                  maxWidth: "100%",
                  maxHeight: "200px",
                  borderRadius: "5px",
                }}
              />
            </div>
          ) : (
            <span className="notice-text" style={{ whiteSpace: "pre-line" }}>
              {ele.message.replace(/<br\s*\/?>/gi, "\n")}
            </span>
          )}
        </div>
      </div>
    </>
  )
}
